import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { MatCalendarHeader } from '@angular/material/datepicker';

@Component({
    selector: 'custom-header',
    templateUrl: 'custom-header.component.html',
    styles: [`
		.mat-calendar-period-button {
			font-size: 18px;
		}
		.mat-calendar-previous-button::after, .mat-calendar-next-button::after {
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			position: absolute;
			content: "";
			margin: 15.5px;
			border: 0 solid currentColor;
			border-top-width: 2px;
		}
		.mat-calendar-previous-button::after {
			border-left-width: 2px;
			transform: translateX(2px) rotate(-45deg);
		}
		.mat-calendar-next-button::after {
			border-right-width: 2px;
			transform: translateX(-2px) rotate(45deg);
		}
	`],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class CustomHeader extends MatCalendarHeader<any> {
	get periodLabel() {
		const activeMonth: number = new Date(this.calendar.activeDate).getMonth(),
			activeYear: number = new Date(this.calendar.activeDate).getFullYear(),
			months = this.calendar.activeDate._locale.months(),
			month: string = months[activeMonth];
		return month[0].toUpperCase() + month.substr(1).toLowerCase() + ' ' + activeYear;
	}

	/** Handles user clicks on the period label. */
	currentPeriodClicked(): void {
		this.calendar.currentView = this.calendar.currentView == 'month' ? 'multi-year' : 'month';
	}

	/** Handles user clicks on the previous button. */
	customPrev(): void {
		this.previousClicked();
	}

	/** Handles user clicks on the next button. */
	customNext(): void {
		this.nextClicked();
	}

	@HostListener('window:mousewheel', ['$event']) onScroll(event) {
		if (!event.target.classList.value.includes('mat-calendar-table') && !event.target.classList.value.includes('mat-calendar-body')) return;
		if (event.deltaY > 0) this.customNext();
		else this.customPrev();
	}
}